import { AutocompleteComponent as Autocomplete } from './Autocomplete';

export default Autocomplete;
